import { ApiService } from '../api.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserToken } from '../../models/user-login.model';
import { map } from 'rxjs/operators';
import { AppService } from '../app.service';
import { LOGIN } from '../../enums/urls';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<UserToken>;
  public currentUser: Observable<UserToken>;

  constructor(
    private commonService: ApiService,
    private appService: AppService,
    private router: Router,

  ) {
    this.currentUserSubject = new BehaviorSubject<UserToken>(this.appService.getUserDetails() || null);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): UserToken {
    return this.currentUserSubject.value;
  }

  login(username: string, password: string) {
    let url = LOGIN.TOKEN;
    const obj = {
      email: username,
      password: password,
    };
    return this.commonService.commonPostHandler(url, obj).pipe(
      map((user) => {
        if (user && user.accessToken) {
          this.appService.setToken(user);
          this.currentUserSubject.next(user);
        }

        return user;
      })
    );
  }

  logout() {
    localStorage.removeItem('currentUser');
    // this.currentUserSubject.next(null);
  }
  gotoHomePage() {
    this.router.navigate(['./']);
  }
}
